import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import PreviewIcon from '@mui/icons-material/Preview';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GavelIcon from '@mui/icons-material/Gavel';
import AddTaskIcon from '@mui/icons-material/AddTask';
import TaskIcon from '@mui/icons-material/Task';
import GridViewIcon from '@mui/icons-material/GridView';
import LaunchIcon from '@mui/icons-material/Launch';
import ConfirmationDialog from './ConfirmationDialog'
import JSONForm from './JSONForm'
import ViewDocx from './ViewDocx'
import RefreshIcon from '@mui/icons-material/Refresh';
import TransformerResultDetail from './TransformerResultDetail';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import StepButton from '@mui/material/StepButton';
import Stack from '@mui/material/Stack';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import BugReportIcon from '@mui/icons-material/BugReport';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import CaseFacts from './CaseFacts'
import DocumentProgress from './DocumentProgress'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
import { JsonEditor } from 'json-edit-react'
import { HOST } from '../components/config';

const GenerateDocumentDetail = (props) => {
  const { caseId } = useParams();

  const [showLoadingDocInputs, setShowLoadingDocInputs] = useState(true);
  const [showLoadingTemplateJson, setShowLoadingTemplateJson] = useState(true);

  const showLoading = showLoadingDocInputs || showLoadingTemplateJson;

  const caseDocumentInfo = props.assemblyCaseDocumentInfo;
  const assemblyCaseDocumentId = props.assemblyCaseDocumentInfo.id;
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [showOutput, setShowOutput] = useState(props.showOutput || true)
  const [showFacts, setShowFacts] = useState(false)
  const [showDocuments, setShowDocuments] = useState(false)
  const [showGenerate, setShowGenerate] = useState(true)
  const [showProcessors, setShowProcessors] = useState(false)
  const [previewType, setPreviewType] = useState(null); 

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '80%',
    border: '3px solid grey[200]',
    boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    p: 4,
  };
  
  const submodalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const widgetContainerStyle = {
    backgroundColor: '#FAFAFA', 
    borderColor: "#E2E8F0",
    borderRadius: 2,
    mt: 0.5,
    mb: 1
  }
  
                
  const widgetInteriorStyle={  
                  p: 1,
                  pl: 1.5,
                  borderBottom: 1,
                  borderBottomColor: "#DDE2E5",
                    cursor: 'pointer',
                    transition: '0.2s',
                    '&:hover': { bgcolor: 'action.hover' },
                    '&:focus-visible': { outline: '2px solid', outlineOffset: 2 }
                }
  const transformers = props.transformers
  const transformerResults = props.results
  const [isGenerating, setIsGenerating] = useState(false);
  const [results, setResults] = useState([]);
  const [resultRuns, setResultRuns] = useState([]);
  const [resultInfo, setResultInfo] = useState([]);
  const [templateJson, setTemplateJson] = useState({});
  const [assemblyDocumentInputsInfo, setAssemblyDocumentInputsInfo] = useState([]);
  const [inputDocumentsInfo, setInputDocumentsInfo] = useState({});
  const [pendingResultToDeleteId, setPendingResultToDeleteId] = useState(null);
  const [pendingOutputViewResultJson, setPendingOutputViewResultJson] = useState(null);

  const [assemblyTransformerModalId, setAssemblyTransformerModalId] = useState(null); 

  const fetchAssemblyDocInputs = () => {
    fetch(HOST + '/api/assembly_document_assembly_document_inputs/?assembly_document_id='+ caseDocumentInfo.assembly_document_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setAssemblyDocumentInputsInfo(json)
      setShowLoadingDocInputs(false)
      json.map((doc) => fetchInputDocument(doc.assembly_document_source_id) ) 
   })
  }
  const handleUpdateCaseDocTemplateJson = async (newTemplateJson) => {
      try {
        fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId + '/',
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
          "body": JSON.stringify({ template_json: newTemplateJson }) 
         })
        .then((res) => res.json())
        .then((json) => {
          setTemplateJson(newTemplateJson)
          props.reloadInfo()
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };
  const handleCaseDocDownload = async () => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
  const fetchCaseDocumentTemplateJsonToEdit= async () => {
    try {
      const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
      });
      const json = await response.json()
      setShowLoadingTemplateJson(false)
      setTemplateJson(json.template_json)
    }
    catch (err) {
    }
  }
  const handlePreview= async () => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        setPreviewUrl(download_url)
        setPreviewType(json['generate_filetype'])
      } catch (err) {
      }   
    };
  const fetchInputDocument = (assembly_doc_id) => {
    fetch(HOST + '/api/assembly_documents/'+ assembly_doc_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setInputDocumentsInfo((prevState) => ({...prevState, [assembly_doc_id]: json })   )
   })
  }
  const handleRunDownload = async (run_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs/' + run_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
 
  const inputFactsPrepared = () => {
    return false 
  }

  const inputDocumentsPrepared = () => {
    return false 
  }
  
  const transformersComplete = () => {
    return false 
  }

  useEffect( () => {
    setShowLoadingDocInputs(true)
    setShowLoadingTemplateJson(true)
    fetchAssemblyDocInputs()
    fetchCaseDocumentTemplateJsonToEdit() 
    const intervalId = setInterval(() => { 
      fetchCaseDocumentTemplateJsonToEdit()
 }, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };
  }, [props.assemblyCaseDocumentInfo]);

  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  
  const paginationModel = { page: 0, pageSize: 10 };
  
  const handleCaseDocGenerate = async (assembly_case_document_id) => {
      setIsGenerating(true) 
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id+'/generate/', { 
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
      } catch (err) {
      }   
  };
  const getStatusChip = (item) => { return(item.status == 'SUCCESS' ? 
        (<Chip  className="chip-boxy" label="Generated" color="success" variant="" />) : 
        item.status.includes('ERROR') ?  
        (<Chip  className="chip-boxy" label={"Generation Error"} color="error" variant="" />) :
        item.status.includes('PREPARE') ?  
        (<Chip  className="chip-boxy"  label="Pending Generation" color="warning" variant="" />) : 
        (<Chip  className="chip-boxy"  label="Generating" color="info" variant="" />)) 
  }
  
  const format_date = (d) => (new Date(d)).toLocaleString()
  const isProcessing = caseDocumentInfo.generated_status =='GENERATING' 
  const hasError = caseDocumentInfo.generated_status == 'ERROR' 
  const success = caseDocumentInfo.generated_status == 'SUCCESS' 

  useEffect( () => {
    if (caseDocumentInfo.is_context_document && transformers.length == 1) {
      const first_transformer_id = transformers[0].id
      const transformer_info = transformerResults.filter((item) => item.transformer_id == first_transformer_id)[0] 
      if (transformer_info) {
        if (transformer_info.total == 0 || transformer_info.total != transformer_info.count_success)
          setAssemblyTransformerModalId(transformers[0].id)
      }
    }
  }, [transformerResults]);

  const contextDocStepOffset = caseDocumentInfo.is_context_document ? -2 : 0 
  const docxPreviewer = <ViewDocx docUrl={previewUrl} docType={previewType}/>
  const input_document_ids = assemblyDocumentInputsInfo.map((item) => item.assembly_document_source_id) 

  const documentStep = ( () => {
    if (success)
      return 'Generate'
    else if (caseDocumentInfo.is_context_document && transformers.length > transformerResults.length) 
      return 'Run Processors'
    else if (success)
      return 'Generate'
    else if (transformerResults.filter((item) => item.total == 0 || (item.total != item.count_success)).length > 0) 
      return 'Run Processors'
    else
      return 'Review Result' 
  })()

  const inputsLastUpdatedAt = caseDocumentInfo.inputs_updated_at || caseDocumentInfo.created_at
  if (showLoading)
    return     <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={120}    // keeps the area from collapsing
    >
      <CircularProgress
        size={40}        // px
        thickness={4}    // stroke-width
        color="primary"  // any theme palette key or custom CSS
      />
    </Box>
  return (  <Box sx={{p: 0.5, overflow: 'scroll', backgroundColor: "#ECEFF1"}}>
     
            
          { false && !caseDocumentInfo.is_context_document && caseDocumentInfo.generate_filetype && 
              <Box sx={widgetContainerStyle} > 
              <Box   
              display="flex" 
                alignItems="center"   
                elevation="5"
                onClick={() => setShowGenerate(!showGenerate)}
                 
                sx={widgetInteriorStyle}
                >
              <Typography sx={{ fontWeight: "900" }} flexGrow='1' >
                  Generate {caseDocumentInfo.generate_filetype.toUpperCase()}
              </Typography>
              <IconButton size='small' edge="end">
                <KeyboardArrowDownIcon size='small' />
              </IconButton>
              </Box>
              <Collapse in={showGenerate} >
                <Box   
                  alignItems="center"   
                  elevation="1"
                  sx={{  
                  
                  }}>
              <Grid container spacing={2}>
                <Grid item xs={12} >
                    {hasError &&
                      <Alert severity="error">
                        <Typography variant='subtitle' component="div" sx={{ flexGrow: 1 }}>
                          Document Generation Failed . 
                        </Typography>
                      </Alert>
                    }
                    {caseDocumentInfo.generated_status == 'SUCCESS' &&
                    <>
                      {caseDocumentInfo.generated_at &&
                        <> 
                          { caseDocumentInfo.generated_at < inputsLastUpdatedAt &&
                            <Alert severity="warning">
                              <Typography variant='subtitle' component="div" sx={{ flexGrow: 1 }}>
                                <b>Needs Regeneration:</b> Context has changed since last generated. 
                              </Typography>
                            </Alert>
                          }
                          { caseDocumentInfo.generated_at >= inputsLastUpdatedAt &&
                            <Alert severity="success">
                              <Typography variant='subtitle' component="div" sx={{ flexGrow: 1 }}>
                                Generated Document is up-to-date with changes. 
                              </Typography>
                            </Alert>
                          }
                        </>
                      
                      }
                    </>
                    }
                  </Grid>
                </Grid>
              { !isProcessing &&
                <>
                  { caseDocumentInfo.generated_at &&
                    <Box sx={{ mb: 1 }}>
                      
                      <Alert severity="info">
                        Last generated on {  format_date(caseDocumentInfo.generated_at) }
                      </Alert>
                    </Box>
                  }
                  <Button 
                    sx={{width: '100%'}} 
                    variant="outlined" 
                    disabled={isProcessing}
                    color="primary" 
                    component="span" 
                    onClick={() => handleCaseDocGenerate(caseDocumentInfo.id)}>
                    <GavelIcon /> 
                    &nbsp;Generate 
                  </Button>
                </>
              }
              {isProcessing &&
                <>
                  <Alert severity="info">
                    <Typography variant='subtitle' component="div" sx={{ flexGrow: 1 }}>
                      Document Generating... 
                    </Typography>
                  </Alert>
                  <Button 
                    sx={{width: '100%'}} 
                    variant="outlined" 
                    disabled={false}
                    color="error" 
                    component="span" 
                    onClick={() => handleCaseDocGenerate(caseDocumentInfo.id)}>
                    <GavelIcon /> 
                    &nbsp;Force Re-Generate 
                  </Button>
                </>
              }
            </Box>
            </Collapse>
          </Box>
          }
            {transformerResults.length > 0 && transformerResults.map((item, ind) =>               {
              return (<Box sx={widgetContainerStyle} > 
              <Box   display="flex" 
                alignItems="center"   
                elevation="5"
                onClick={() => setShowProcessors(!showProcessors)}
                 
                sx={widgetInteriorStyle}
                >
              <Typography sx={{ fontWeight: "900" }} flexGrow='1' >
                    <b style={{marginRight: "5px" }} x={{mr: 2}}>
                      {true ? "Prepare: " + item.label : item.label}
                    </b> 
             </Typography>
              <Box edge='end' inline>
                                {item.count_processing == 1 ? 
                                (<Chip  className="chip-boxy" sx={{m: 0}} label={'Running'} color="info" variant="" />)  : 
                                item.count_processing > 1 ? 
                                (<Badge badgeContent={item.count_processing} color="info"><Chip  className="chip-boxy" label={'Running'} color="info" variant="" /></Badge>)  : 
                                item.count_errored > 0 ?  
                                (<Badge badgeContent={item.count_errored} color="error"><Chip  className="chip-boxy" label={'Errored'} color="error" variant="" /></Badge>) :
                                item.count_success > 1 ?  
                                (<Badge badgeContent={item.count_success} color="success"><Chip  className="chip-boxy" label={'Success'} color="success" variant="" /></Badge>): 
                                item.count_success == 1 ?  
                                (<Chip  className="chip-boxy" sx={{ m: 0}} label={'Success'} color="success" variant="" />) : 
                                (<Chip  className="chip-boxy" sx={{ m: 0}} label={'Needs Review'} color="warning" variant="" />)} 
              <IconButton size='small' edge="end">
                <KeyboardArrowDownIcon size='small' />
              </IconButton>
              </Box>
              </Box>
              <Collapse in={showProcessors} >
                <Box   
                  display="flex" 
                  alignItems="center"   
                  elevation="1"
                  sx={{  
                  }}>
                <TransformerResultDetail 
                  // TODO: add to logs view with this removed
                  hideDetails={true}
                  assemblyTransformerId={item.transformer_id} 
                  assemblyCaseDocumentId={caseDocumentInfo.id} 
                  caseDocumentInfo={caseDocumentInfo}
                  onCancel={() => setAssemblyTransformerModalId(null)}
                  />
                </Box>
              </Collapse>
            </Box>)
            })}
              <Box sx={widgetContainerStyle} > 
              <Box   display="flex" 
                alignItems="center"   
                elevation="5"
                onClick={() => setShowOutput(!showOutput)}
                 
                sx={widgetInteriorStyle}
                >
              <Typography sx={{ fontWeight: "900" }} flexGrow='1' >
                {caseDocumentInfo.is_context_document &&
                  "Review Facts"
                }
                {!caseDocumentInfo.is_context_document &&
                  <>Review Fields</> 
                }
              
             </Typography>
              <IconButton size='small' edge="end">
                <KeyboardArrowDownIcon size='small' />
              </IconButton>
              </Box>
              <Collapse in={showOutput} >
                <Box   
                  display="flex" 
                  alignItems="center"   
                  elevation="1"
                  sx={{  
                    pl: 2,
                    pr: 2,
                  }}>
                    <JSONForm useFormDisplay={false} title={""} template_json={templateJson} handleOnSubmit={(newTemplateJson) => handleUpdateCaseDocTemplateJson(newTemplateJson)} /> 
                </Box>
              </Collapse>
            </Box>
        {input_document_ids && input_document_ids.length > 0 &&

              <Box sx={widgetContainerStyle} > 
              <Box   display="flex" 
                alignItems="center"   
                elevation="5"
                onClick={() => setShowFacts(!showFacts)}
                 
                sx={widgetInteriorStyle}
                >
              <Typography sx={{ fontWeight: "900" }} flexGrow='1' >
                  Facts
              </Typography>
              <IconButton size='small' edge="end">
                <KeyboardArrowDownIcon size='small' />
              </IconButton>
              </Box>
              <Collapse in={showFacts} >
                <Box   
                display="flex" 
                  alignItems="center"   
                  elevation="1"
                  sx={{  
                    pl: 2,
                    pr: 2,
                  }}>
                <CaseFacts setPreviewDocumentId={props.setPreviewDocumentId} context={true} showOutput={true} preview={true} caseId={caseId} docIdFilter={input_document_ids} /> 
                </Box>
              </Collapse>
            </Box>
        }
        {input_document_ids && input_document_ids.length > 0 &&
              <Box sx={widgetContainerStyle} > 
              <Box   display="flex" 
                alignItems="center"   
                elevation="5"
                onClick={() => setShowDocuments(!showDocuments)}
                 
                sx={widgetInteriorStyle}
                >
              <Typography sx={{ fontWeight: "900" }} flexGrow='1' >
                 Documents 
              </Typography>
              <IconButton size='small' edge="end">
                <KeyboardArrowDownIcon size='small' />
              </IconButton>
              </Box>
              <Collapse in={showDocuments} >
                <Box   display="flex" 
                  alignItems="center"   
                  elevation="1"
                  sx={{  
                    pl: 2,
                    pr: 2,
                  }}>
                  <CaseFacts setPreviewDocumentId={props.setPreviewDocumentId} context={false} preview={true} caseId={caseId} docIdFilter={input_document_ids } /> 
                </Box>
              </Collapse>
            </Box>
          }
          
          </Box>
)
}

export default GenerateDocumentDetail;

